import React, { useState } from 'react';
import { useQuery } from 'react-query';
import useGetTagsInUse from '../../api/useGetTagsInUse';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from 'reactstrap';
import { Link } from 'react-router-dom';
import DisplayQueryError from './DisplayQueryError';
import LoadingSpinner from './LoadingSpinner';

interface TopicDropDownProps {
    tagText: string;
}

const TopicDropDown: React.FC<TopicDropDownProps> = ({ tagText }) => {
    const getTagsInUse = useGetTagsInUse();
    const {
        data: tags,
        isLoading,
        error,
        refetch
    } = useQuery('tagsInUse', getTagsInUse);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    if (error) {
        return <DisplayQueryError error={error} refetch={refetch} />;
    }

    if (isLoading || !tags) {
        return <LoadingSpinner />;
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle
                color='white'
                className='btn-white'
                id='dropdownMenuButton'
                caret
            >
                {tagText}
            </DropdownToggle>
            <DropdownMenu
                style={{
                    maxHeight: '300px',
                    overflowY: 'auto'
                }}
            >
                {tags.map((tag, index) => (
                    <DropdownItem
                        key={index}
                        tag={Link}
                        to={`/topic/${encodeURIComponent(tag.text)}`}
                    >
                        {tag.text}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default TopicDropDown;
